export default __webpack_public_path__ + "static/profile-card-sy-d07be66327e271696debcbe57b88e4d4.jpg";